import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { onEnterOrSpacePress } from '@hivebrite/utils';
import { Box } from "../../../box/src";
import { CATEGORIES, FontAwesomeIcon } from "../../../font-awesome-icon/src";
import { ScreenReadersContent } from "../../../screen-readers-content/src";
import { Cell } from './Cell';
import { Row } from './Row';
import { SORT_VALUES } from '../constants';
import { getSortedColumnColor, getSortedColumnIcon, switchSort, } from '../utils';
export const ColumnHeaders = ({ columns, onSort, }) => {
    const [activeColumn, setActiveColumn] = useState();
    const [sortedColumns, setSortedColumns] = useState({});
    const handleSort = (key) => {
        setActiveColumn((prevActive) => {
            setSortedColumns((prevSorted) => {
                const newSortedValue = prevSorted[key] && prevActive === key
                    ? switchSort(prevSorted[key])
                    : SORT_VALUES.ASCEND;
                onSort === null || onSort === void 0 ? void 0 : onSort(key, newSortedValue);
                return Object.assign(Object.assign({}, prevSorted), { [key]: newSortedValue });
            });
            return key;
        });
    };
    return (_jsx(Row, { as: "thead", display: "table-header-group", children: _jsx(Row, { as: "tr", "data-testid": "ds-table-header-row", display: "table-row", children: columns.map((column) => {
                var _a;
                const handleClick = () => handleSort(column.key);
                const sortableIconColor = getSortedColumnColor(activeColumn, column.key);
                const sortableIconName = getSortedColumnIcon(sortedColumns, column.key);
                return (_jsxs(Cell, { "$isSortable": column.sortable, "$verticalAlign": "bottom", as: "th", "data-testid": "ds-table-header-cell", font: "body-semibold-asphalt", textAlign: column.textAlign || 'left', width: column.width, children: [((_a = column.renderHeader) === null || _a === void 0 ? void 0 : _a.call(column, {
                            data: column,
                        })) ||
                            column.title || (_jsx(ScreenReadersContent, { children: column.screenReaderContent })), column.sortable && (_jsx(IconWrapper, { "data-testid": "ds-table-icon-sortable", onClick: handleClick, onKeyPress: onEnterOrSpacePress(handleClick), children: _jsx(FontAwesomeIcon, { color: sortableIconColor, height: "12px", iconName: sortableIconName, iconType: CATEGORIES.DUOTONE }) }))] }, column.key));
            }) }) }));
};
const IconWrapper = styled(Box).attrs(() => ({
    display: 'inline',
    ml: 2,
})) `
  cursor: pointer;
`;
//# sourceMappingURL=ColumnHeaders.js.map